/**
 * The two centroids are colour-coded so a field and the point it drives carry
 * the same colour: mass red, stiffness blue.
 */
export const SEISMIC_MASS_COLOR = '#e32f27'
export const SEISMIC_STIFFNESS_COLOR = '#105ba4'
